export const VERTICAL_OFFSET = 20;
export const DAY_WIDTH = 14.28;
export const MOBILE_VERTICAL_OFFSET = 20;
export const MOBILE_QUERY = "(max-width: 450px)";
